import React from 'react';
import {observer} from 'mobx-react';

import './RightBar.scss';
import {Insights} from '../../icons';
import {IHistoryConsoleController} from '../../controller';
import {ScanImageBox} from '../scan-image-box/ScanImageBox';
import {RssiScaleBarOverlay} from '../scan-image-box/RssiScaleBarOverlay';

export interface RightBarProps {
    controller: IHistoryConsoleController;
}

export const RightBar = observer(function RightBar({controller}: RightBarProps): JSX.Element {
    const details = controller.getScanDetails;
    const translate = controller.translate;

    if (!details) {
        return <></>;
    }

    return (
        <div className='history-console-right-bar'>
            <div className='right-bar-header'>
                <h2 className='right-bar-title'>{translate('REACT.HISTORY_CONSOLE.SCAN_DETAILS')}</h2>
            </div>
            <div className={'history-console-general-info'}>
                <div className={'history-console-general-info-section'}>
                    <div className={'history-console-general-info-section-item'}>
                        <p className={'history-console-general-info-section-item-title'}>
                            {translate('REACT.HISTORY_CONSOLE.DATE')}
                        </p>
                        <p className={'history-console-general-info-section-item-info'}>{details.date}</p>
                    </div>
                </div>
                <div className={'history-console-general-info-section'}>
                    <div className={'history-console-general-info-section-item'}>
                        <p className={'history-console-general-info-section-item-title'}>
                            {translate('REACT.INVITE.JOIN_OFFLINE_TABLE.CUSTOMER_ID')}
                        </p>
                        <p className={'history-console-general-info-section-item-info'}>{details.customerId}</p>
                    </div>
                </div>
                <div className={'history-console-general-info-section'}>
                    <div className={'history-console-general-info-section-item'}>
                        <p className={'history-console-general-info-section-item-title'}>
                            {translate('HISTORY.VIEW.RECORDINGS.SESSION_ID')}
                        </p>
                        <p className={'history-console-general-info-section-item-info'}>{details.sessionId}</p>
                    </div>
                </div>
            </div>

            {details.insights && (
                <div className={'right-bar-insights-container'}>
                    <div className={'right-bar-insights-title-container'}>
                        <div className={'icon'}>{Insights}</div>
                        <p>Insights</p>
                    </div>
                    <p className={'right-bar-insights-text'}>{details.insights}</p>
                </div>
            )}

            {details.imageUrl && (
                <ScanImageBox imageUrl={details.imageUrl} className='right-bar-image-container'>
                    <RssiScaleBarOverlay />
                </ScanImageBox>
            )}

            {details.imageUrl && details.details && (
                <div className={'right-bar-details-container'}>
                    <div className={'right-bar-details-container-item'}>
                        <p className={'right-bar-details-container-title'}>
                            {translate('REACT.WIFI_ANALYZER.HISTORY_FLOOR')}
                        </p>
                        <p className={'right-bar-details-container-info'}>{details.details.floor}</p>
                    </div>
                    <div className={'right-bar-details-container-item'}>
                        <p className={'right-bar-details-container-title'}>
                            {translate('REACT.WIFI_ANALYZER.HISTORY_ROOM')}
                        </p>
                        <p className={'right-bar-details-container-info'}>{details.details.room}</p>
                    </div>
                    <div className={'right-bar-details-container-item'}>
                        <p className={'right-bar-details-container-title'}>
                            {translate('REACT.WIFI_ANALYZER.HISTORY_NOTES')}
                        </p>
                        <p className={'right-bar-details-container-info'}>{details.details.note}</p>
                    </div>
                </div>
            )}

            <div className={'right-bar-data-container'}>
                {(details.info ?? []).map((item, i) => (
                    <div key={i} className={'right-bar-data-item'}>
                        <div className={'right-bar-data-item-title'}>
                            <div className={'icon'}>{item.symbol}</div>
                            <p>{item.title}</p>
                        </div>
                        <p className={'right-bar-data-item-text'}>{item.value}</p>
                    </div>
                ))}
            </div>
        </div>
    );
});
